import { render, staticRenderFns } from "./WebCamLite.vue?vue&type=template&id=61bb2afc&scoped=true"
import script from "./WebCamLite.vue?vue&type=script&lang=js"
export * from "./WebCamLite.vue?vue&type=script&lang=js"
import style0 from "./WebCamLite.vue?vue&type=style&index=0&id=61bb2afc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61bb2afc",
  null
  
)

export default component.exports